module.exports = __webpack_public_path__ + "img/Bundesliga_2_Whitelabel_400x416.df0c59fd.jpg";